import React, { Component } from "react";
import Header from "../components/Head";
import Subscribe from "../components/Subscribe";
import Contact from "../components/Contact";
import { withTranslate } from "react-redux-multilingual";
import globalMiddleware from "./../hocs/globalMiddleware";
import {connect} from "react-redux";
import {setCurrentRoute, clearError500} from "../store/actions/globalActions";



class ContactUs extends Component{

    componentDidMount() {
        this.props.clearError500();
        window.scrollTo(0, 0);
        this.props.setCurrentRoute(window.location.href);
    }
    render() {

        const history = [
            {
                page: this.props.translate("home"),
                to: "/"
            }
        ]


        return (
        <div className="About">
            <Header title={ this.props.translate("contact") } history={ history } />

            <Contact />
            <Subscribe />
        </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentRoute: (route) => dispatch(setCurrentRoute(route)),
        clearError500: () => dispatch(clearError500()),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(globalMiddleware(withTranslate(ContactUs)))